
if($('#category-header').length){
  function mhfiltr() { 
    $('.filters-wrapper .filters').before('<div class="filters-unveil-button-wrapper"><a href="#" class="btn btn-default unveil-button" data-unveil="filters" data-text="Otevřít filtr ">Zavřít filtr</a></div>')
    $('.filter-sections').before('<div class="filter-sections first"></div><div class="filter-button"><span class="filter-hover">Rozbalit další</span></div>');
    $('.filter-section-boolean').append('<h4 class="hide">Příznak</h4>')
    $('.filter-section-boolean, .filter-section-parametric-id-58, .filter-section-parametric-id-55, .slider-wrapper, .filter-section-parametric-id-46, .filter-section-parametric-id-71').appendTo('.filter-sections.first')
    var findactiive = $('#category-filter-hover').find('label.active')
    if($(findactiive).length > 0){

      $('#category-filter-hover').toggleClass('ukaz')
      $('.filter-hover').toggleClass('open-filter')
    }
    $('.filter-hover').click(function(){
      $('#category-filter-hover').toggleClass('ukaz')
      $(this).toggleClass('open-filter')
    });
    $('.filter-section h4').click(function(){
        $(this).closest('.filter-section').toggleClass('open');
    });
    $('.slider-wrapper h4').click(function(){
        $(this).closest('.slider-wrapper').toggleClass('open');
    });
    $('.filter-label').each(function(){
        var findh = $(this).closest('.filter-section').find('h4').text();
        $(this).prepend('<span class="filter-title">'+findh+' -</span>')
    })
    $(function() {
      var loc = window.location.href;
      if(/priceMin/.test(loc)) {
        $('body').addClass('cena-yes');
      }
    });
        if($('.vybrane-filtry').length == 0) { 
          $('<div class="vybrane-filtry"></div>').insertBefore("#products"); 
          setTimeout( function(){
          $('.filter-section:not(".nofind-label") .filter-label.active').clone().appendTo(".vybrane-filtry");
          $('#clear-filters').clone().appendTo('.vybrane-filtry');
          },2);
          $(".vybrane-filtry .filter-label.active").closest("div").addClass("aktivni-filtr"); 
          $(".vybrane-filtry .filter-section fieldset div:not(.aktivni-filtr)").remove(); 
          
          $('#clear-filters').on('click', function(){
              $('body').removeClass('cena-yes')
          });
          setTimeout( function(){
              $(".cena-yes .slider-wrapper").clone().prependTo(".vybrane-filtry");
              $('.vybrane-filtry').addClass('aktivni-filtr')
              $('.vybrane-filtry .slider-wrapper').click( function() {
     
              document.location.href = String( document.location.href ).replace( "priceMin", "" ).replace( "priceMax", "" );
              });
              }, 2);
        }
    }



$(document).ready(function() { 
    mhfiltr(); 
});  
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
  mhfiltr();
});  

}

